import { Model } from '@vuex-orm/core'

export default class Intervideo extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'intervideos'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      videoform_id: this.attr(null),
      name: this.attr(null),
      placement_id: this.attr(null),
      candidate_id: this.attr(null),
      avg_rating: this.attr(null),
      questions: this.attr(null),
      ratings: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Intervideo.js